import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkBanner',
  props: {
    href: { type: [String, Boolean], default: false }
  },
  setup(__props: any) {



const shouldBeRed = computed(()=> {
	const today = Date.now();
	return today > new Date("4/11/24").getTime() && today < new Date("4/18/24").getTime();
});

return { __sfc: true,shouldBeRed, Icon }
}

})